import ConfirmModal from './confirm_modal';

export default ConfirmModal;
